import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import api from '@/api/api'
import { Dialog } from 'vant';
import moment from 'moment';
import filter from '@/shared/services/filters';
import { dictionary } from '@/shared/services/dictionary';
@Component({
    filters: {
        formatDateMon: filter.formatDateMon,
        formatDateDay: filter.formatDateDay,
        nullString: filter.nullString,
    },
})
export default class AddResumeOptionalInfo extends Vue {
    @Prop() data: any; // 选填信息
    @Prop() areaList: any; // 地区信息
    @Prop() inResume: any; // 是否在录用简历中
    areaProps: any = {}; // 省市组件属性
    radioList: any = [{ id: true, text: '是' }, { id: false, text: '否' }]; // radio选项
    memberRelationList: any = []; // 家庭成员关系数据源
    positionList: any = []; // 职位数据源
    knowLevelList: any = []; // 掌握程度数据源

    optionalInfo: any = {
        familyMembers: [],
        benefits: [],
        projects: [],
        skills: [],
        rewards: [],
        languages: [],
        trains: [],
    }
    familyInfo: any = {}; // 家庭成员
    benefitInfo: any = {}; // 特殊关系  
    projectInfo: any = {}; // 项目经历
    skillInfo: any = {}; // 专业技能  
    rewardInfo: any = {}; // 证书
    languageInfo: any = {}; // 语言能力
    trainInfo: any = {}; // 培训经历
    isLoading: boolean = false; //完成按钮禁用
    created() {
        // 初始化省市信息
        this.initAreaInfo();
        // 获取职位列表
        this.getHRCenterPositions();
        // 获取掌握程度列表
        this.getKnowLevels();
        // 获取家庭成员关系列表
        this.getMemberRelations();
        // 再次进入赋值
        if (this.data) {
            this.optionalInfo = this.data;
            if (this.data.benefits && this.data.benefits.length > 0) {
                this.benefitInfo = this.data.benefits[0];
            }
        }
    }

    // 监听简历信息变化
    @Watch('data')
    onDataChanged(val: any, oldVal: any) {
        this.optionalInfo = val;
        if (val.benefits && val.benefits.length > 0) {
            this.benefitInfo = val.benefits[0];
        }
    }

    // 初始化省市信息
    initAreaInfo() {
        this.areaProps = {
            expandTrigger: 'hover',
            label: 'name',
            value: 'code',
            lazy: true,
            lazyLoad(node: any, resolve: any) {
                const { level } = node;
                if (node.data && node.level < 2) {
                    api.getCityInfoById(node.data.id).then((res: any) => {
                        let nodes = res.districtDetails || null;
                        if (nodes && nodes.length > 0) {
                            nodes = nodes.map((item: any) => {
                                item.leaf = (node.level === 1)
                                return item
                            });
                        }
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    }).catch((error: any) => {
                        Dialog.alert({
                            title: '提示',
                            message: '地区数据获取失败：' + error,
                        });
                    });
                } else {
                    resolve(null);
                }
            }
        };
    }

    // 获取职位列表（利益关系）
    getHRCenterPositions() {
        let param: any = {};
        param.filter = param.filter || {
            groups: [
                {
                    op: 'and',
                    rules: [
                        {
                            field: 'levelNo',
                            op: 'eq',
                            data: '3',
                        }
                    ]
                }
            ],
        };
        api.getHRCenterPositionsInfo(param).then((res: any) => {
            if (res.data) {
                this.positionList = res.data;
            }
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '职位数据获取失败：' + error,
            });
        });;
    }

    // 获取掌握程度列表
    getKnowLevels() {
        api.getDictionaries([dictionary.knowLevel]).then((res: any) => {
            this.knowLevelList = res.data || [];
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '数据获取失败：' + error,
            });
        });
    }

    getMemberRelations() {
        api.getDictionaries([dictionary.memberRelation]).then((res: any) => {
            this.memberRelationList = res.data || [];
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '数据获取失败:' + error,
            });
        })
    }

    // 更新input组件值，避免因组件嵌套太深出现input值未更新的情况
    updateInput() {
        this.$forceUpdate();
    }

    // 选择家庭成员-联系地址
    changeAddress(event: any) {
        const addressNode = (this as any).$refs.addressCascader.getCheckedNodes()[0];
        if (addressNode && addressNode.path) {
            this.familyInfo.addressProCode = addressNode.path[0];
            this.familyInfo.addressCityCode = addressNode.path[1];
            this.familyInfo.addressProName = addressNode.pathLabels[0];
            this.familyInfo.addressCityName = addressNode.pathLabels[1];
        }
    }

    // 选择是否曾/在中瑞工作
    changeBenefit(event: any, type: number) {
        if (type === 1) {
            if (!event) {
                this.benefitInfo.positionName = null;
                this.benefitInfo.departName = null;
            }
        } else if (type === 2) {
            if (!event) {
                this.benefitInfo.benefitName = null;
                this.benefitInfo.benefitPosition = null;
                this.benefitInfo.benefitDepart = null;
                this.benefitInfo.benefitDesc = null;
            }
        }
    }
    // 选择掌握程度
    changeKnowLevel(event: any, type: any) {
        let knowLevel = this.knowLevelList.find((m: { name: any; }) => m.name === event);
        if (knowLevel) {
            if (type === 1) {
                this.skillInfo.knowLevelId = knowLevel.id;
                this.skillInfo.knowLevel = knowLevel.name;
            } else if (type === 2) {
                this.languageInfo.knowLevelId = knowLevel.id;
                this.languageInfo.knowLevel = knowLevel.name;
            }
        }
    }

    /**
     * 选择家庭成员关系
     *
     * @memberof AddResumeOptionalInfo
     */
    changeMemberRelation(event: any) {
        let memberRelation = this.memberRelationList.find((m: { name: any; }) => m.name === event);
        if (memberRelation) {
            this.familyInfo.memberRelationId = memberRelation.id;
            this.familyInfo.memberRelation = memberRelation.name;
        }
    }

    // 添加家庭成员
    addFamilyMembers() {
        if (!this.optionalInfo.familyMembers) {
            this.optionalInfo.familyMembers = [];
        }
        if (this.familyInfo && this.familyInfo.memberName && this.familyInfo.memberRelation) {
            if (this.familyInfo.birthdayDate && moment(new Date()).isBefore(this.familyInfo.birthdayDate)) {
                this.$message({
                    message: '出生年月不可晚于当前日期',
                    type: 'warning'
                });
                return
            }
            this.optionalInfo.familyMembers.push(this.familyInfo);
            this.familyInfo = {};
        }
    }

    // 添加经历
    addExperience(type: string, typeInfo: string) {
        if (!this.optionalInfo[type]) {
            this.optionalInfo[type] = [];
        }
        const itemInfo = (this as any)[typeInfo];
        if (itemInfo && (this.projectInfo.projectName || this.skillInfo.skillName || this.rewardInfo.rewardName
            || this.languageInfo.languageName || this.trainInfo.trainDepart)) {
            if (itemInfo.startTime && itemInfo.endTime
                && moment(itemInfo.endTime).isBefore(itemInfo.startTime)) {
                this.$message({
                    message: '结束时间不可早于开始时间',
                    type: 'warning'
                });
                return
            }
            this.optionalInfo[type].push(itemInfo);
            (this as any)[typeInfo] = {};
        }
    }

    // 删除经历
    deleteExperience(index: any, type: string) {
        this.optionalInfo[type].splice(index, 1);
        this.updateInput();
    }

    // 上一步
    goBack() {
        const data = {
            currentStep: 5,
            move: 'back',
        };
        this.$emit('getRecruitInfo', data);
    }

    // 完成
    save() {
        this.isLoading = true;
        if (this.benefitInfo) {
            this.optionalInfo.benefits = [];
            this.optionalInfo.benefits[0] = this.benefitInfo;
        }
        const data = {
            currentStep: 5,
            move: 'next',
            fromInfo: this.optionalInfo,
        };
        this.$emit('getRecruitInfo', data);
    }
}
